<template>
	<v-row class="mt-3">
		<v-col cols="12" sm="4" v-for="n in 3" :key="n">
			<v-card elevation="2" rounded="xl">
				<v-skeleton-loader type="article" class="pa-2"></v-skeleton-loader>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
export default {};
</script>
